import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type FetchVacancyResponse = components['schemas']['ExtendedVacancy'];
export type FetchVacancyPath = NonNullable<paths['/executor_web/vacancies/{id}']['get']['parameters']['path']>;

/** GET `/api/executor_web/v1/executor_web/vacancies/{id}` — см. `paths['/executor_web/vacancies/{id}']` в openapi */
export function fetchVacancy(path: FetchVacancyPath, signal?: AbortSignal) {
	return axiosInstance.get<FetchVacancyResponse>(`vacancies/${path.id}`, {signal});
}
